import React from 'react'
import { Button, Modal } from 'antd'
import DeleteIcon from '@mui/icons-material/Delete'

import { manageToast } from '../../../components/Common/ManageToast'
import { serverlessApi } from '../../../utils/API'

function InternalKeyDeleteModal (props) {
  const { open, onClose, triggerCollectionRefetch, internalKey } = props

  const [loading, setLoading] = React.useState(false)

  const handleInternalKeyRemove = () => {
    if (!internalKey) {
      return
    }

    return Promise.resolve()
      .then(() => setLoading(true))
      .then(() => {
        return serverlessApi.deleteInternalKey(internalKey._id).then(() => {
          triggerCollectionRefetch()
          manageToast(true, `Internal Key "${internalKey.InternalKeyName}" 
          deleted successfully`)
          setLoading(false)
          onClose()
        })
      })
      .catch(() => {
        manageToast(false, 'Error deleting lockBox')
        setLoading(false)
      })
  }

  return (
    <Modal
      title='Remove internal key'
      open={open}
      footer={null}
      onCancel={onClose}
    >
      Are you sure you want to remove internal key "{internalKey?.InternalKeyName}" ?
      <div className="flex gap-2 justify-end pt-7">
        <Button
          className="hover:!text-black hover:!border-labelGrey"
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          className="inline-flex items-center"
          onClick={handleInternalKeyRemove}
          loading={loading}
          icon={<DeleteIcon className="!w-[20px]" />}
          type="primary"
          danger
        >
          Remove internal key
        </Button>
      </div>
    </Modal>
  )
}

export default InternalKeyDeleteModal
